import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataViewResponseTypes, SwitchViewResponseTypes } from '@mode/shared/contract-common';
import { MetaTags, MetaTagsService } from '@mode/shared/util-js';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SwitchAttrsClientService {
  constructor(
    private http: HttpClient,
    private metaTags: MetaTagsService
  ) {}

  private getOrg() {
    const orgId = this.metaTags.getTag(MetaTags.OwnerUsername);

    if (!orgId) {
      throw new Error('orgId missing from meta tags! It should be in the owner-username tag');
    }

    return orgId;
  }

  /**
   * @description Create a SwitchView attribute
   * @param switchViewToken SwitchView token
   * @param attr
   */
  public createAttr(
    switchViewToken: string,
    attr: DataViewResponseTypes.SwitchViewAttr.RequestAttr
  ): Observable<SwitchViewResponseTypes.SwitchViewAttrResource> {
    const request = `/api/${this.getOrg()}/switch_views/${switchViewToken}/switch_attrs`;
    const data: DataViewResponseTypes.SwitchViewAttr.Create = { attr };

    return this.http
      .post<DataViewResponseTypes.SwitchViewAttr.CreateResponse>(request, data)
      .pipe(map((response) => response));
  }

  /**
   * @description Update a SwitchView attribute
   * @param switchViewToken SwitchView token
   * @param token SwitchView.Attribute token
   * @param attr
   */
  public updateAttr(
    switchViewToken: string,
    token: string,
    attr: DataViewResponseTypes.SwitchViewAttr.RequestAttr
  ): Observable<SwitchViewResponseTypes.SwitchViewAttrResource> {
    const request = `/api/${this.getOrg()}/switch_views/${switchViewToken}/switch_attrs/${token}`;
    const data: DataViewResponseTypes.SwitchViewAttr.Update = { attr };

    return this.http
      .patch<DataViewResponseTypes.SwitchViewAttr.UpdateResponse>(request, data)
      .pipe(map((response) => response));
  }

  /**
   * @description Delete a SwitchView attribute
   * @param token SwitchView.Attribute token
   * @param switchViewToken SwitchView token
   */
  public deleteAttr(token: string, switchViewToken: string): Observable<void> {
    const request = `/api/${this.getOrg()}/switch_views/${switchViewToken}/switch_attrs/${token}`;
    return this.http.delete(request).pipe(map(() => {}));
  }
}
